export const ENV = {
   SCANNER_NONPROD_KEY: 't0152KQMAABaMq1ZVLwUJRrLIgWW/6R8iKlB+58fl33WFW3TFw0NmIcwsTuPrFqyNT51OEa+8EpMLew9UiPxEo+jlQSEp//gNRd8wDINURSydcpHO8Gm2arQZPPT5mzrryXxxfgz6dIYnjPqm7mdszMzXDtnO3BueMOobM3Nn7D3HPEQOBe0tM40MTxj1Tct8N0JrFA38Ax26pn8=',
   SCANNER_PROD_KEY: ''
};
